import React from "react";
import { useTranslation } from "react-i18next";
import { Select, DatePicker } from "antd";
import dayjs from "dayjs";
import {
  AssetOverallHeaderSection,
  FilterRow,
  FilterItem,
  FilterLabel,
  HeaderTitle,
  HeaderDescription,
} from "../styles";

const { RangePicker } = DatePicker;

interface AssetOverallHeaderProps {
  tradingType: string;
  setTradingType: (value: string) => void;
  walletType: string;
  setWalletType: (value: string) => void;
  transactionType: string;
  setTransactionType: (value: string) => void;
  dateRange: [dayjs.Dayjs | null, dayjs.Dayjs | null];
  setDateRange: (value: [dayjs.Dayjs | null, dayjs.Dayjs | null]) => void;
}

const AssetOverallHeader: React.FC<AssetOverallHeaderProps> = ({
  tradingType,
  setTradingType,
  walletType,
  setWalletType,
  transactionType,
  setTransactionType,
  dateRange,
  setDateRange,
}) => {
  const { t } = useTranslation();

  const tradingTypeOptions = [
    { value: "real", label: t("futuresTrading") },
    { value: "copy", label: t("copyTrading") },
    { value: "bot", label: t("botTrading") },
  ];

  const walletTypeOptions = [
    { value: "all", label: t("allWallets") },
    { value: "0", label: t("spotWallet") },
    { value: "1", label: t("futuresWallet") },
  ];

  const transactionTypeOptions = [
    { value: "all", label: t("allTransactions") },
    { value: "DEPOSIT", label: t("deposit") },
    { value: "WITHDRAWAL", label: t("withdrawal") },
    { value: "ADMIN_DEPOSIT", label: t("adminDeposit") },
    { value: "TRANSFER_IN", label: t("transferIn") },
    { value: "TRANSFER_OUT", label: t("transferOut") },
    { value: "TRADE_FEE", label: t("tradeFee") },
    { value: "REALIZED_PNL", label: t("realizedPnl") },
    { value: "COMMISSION", label: t("referralCommission") },
    { value: "REWARD", label: t("reward") },
    { value: "FUNDING_FEE_PAID", label: t("fundingFeeMinus") },
    { value: "FUNDING_FEE_RECEIVED", label: t("fundingFeePlus") },
    { value: "LIQUIDATION", label: t("forcedLiquidation") },
  ];

  const selectStyle = {
    width: "100%",
    minWidth: 140,
  };

  return (
    <AssetOverallHeaderSection>
      <HeaderTitle>
        📊 {t("overallHistory")}
      </HeaderTitle>
      <HeaderDescription>
        {t("overallHistoryDescription")}
      </HeaderDescription>

      <FilterRow>
        <FilterItem>
          <FilterLabel>{t("tradingType")}</FilterLabel>
          <Select
            value={tradingType}
            onChange={setTradingType}
            options={tradingTypeOptions}
            style={selectStyle}
          />
        </FilterItem>

        <FilterItem>
          <FilterLabel>{t("walletType")}</FilterLabel>
          <Select
            value={walletType}
            onChange={setWalletType}
            options={walletTypeOptions}
            style={selectStyle}
          />
        </FilterItem>

        <FilterItem>
          <FilterLabel>{t("transactionType")}</FilterLabel>
          <Select
            value={transactionType}
            onChange={setTransactionType}
            options={transactionTypeOptions}
            style={selectStyle}
          />
        </FilterItem>

        <FilterItem>
          <FilterLabel>{t("dateRange")}</FilterLabel>
          <RangePicker
            value={dateRange}
            onChange={(dates) => setDateRange(dates as [dayjs.Dayjs | null, dayjs.Dayjs | null])}
            style={{ minWidth: 240 }}
            allowClear
          />
        </FilterItem>
      </FilterRow>
    </AssetOverallHeaderSection>
  );
};

export default AssetOverallHeader;
